<template>
  <div class="search-openings">
    <form class="form" @submit.prevent="searchOpening">
      <input type="text" class="form__input" name="searchOpenings" :placeholder="$t('home.openings.search_input_placeholder')" v-model="query">
    </form>

    <div>
      <Loader v-if="!hasFetchedAllOpenings" />

      <ul v-else class="opening-list grid">
        <li v-for="opening of allOpenings" v-if="opening.visible" :key="opening.id" class="opening-list__item grid__column">
          <a class="opening" @click="viewOpeningTeam(opening)">
            <div class="opening__text">
              <i :class="opening.team | iconClass"></i>
              <h4>{{opening.team}}</h4>
            </div>

            <span>{{opening.count}}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="section__cta">
      <Button className="button button--navy button--ghost button--rounded" :text="$t('home.openings.see_all')" @click.native="viewOpeningTeam({ team: 'all' })" />

    </div>
  </div>
</template>

<style scoped>
.form {
  margin-bottom: 1.5rem;

  &__input {
    background-image: url(../../assets/img/png/search-icon.png);
    background-repeat: no-repeat;
    background-position: 1rem center;
    background-size: 1.375rem;
    font-size: 0.875rem;
    padding: 0.625rem 0.875rem 0.625rem 3.5rem;
    border-color: transparent;
  }
}

.section__cta {
  padding-top: 2rem;

  .button {
    width: 16rem;
    max-width: 90%;
    margin-bottom: 2rem;
    padding: 0.875rem 1rem;
    font-size: 0.875rem;
  }
}
</style>

<script>
import Button from "../layout/Button";
import Loader from "../layout/Loader";

export default {
  name: "OpeningsSearch",
  data() {
    return {
      query: ""
    };
  },
  created() {
    // force initial state
    this.$store.dispatch("openings/hasFetchedAllOpenings", false);
    this.$store.dispatch("openings/fetchAllOpenings", null);
  },
  mounted() {
    this.fetchOpenings();
  },
  computed: {
    allOpenings() {
      return this.$store.getters["openings/allOpeningsByTeam"];
    },

    hasFetchedAllOpenings() {
      return this.$store.getters["openings/hasFetchedAllOpenings"];
    }
  },
  methods: {
    viewOpeningTeam(opening) {
      this.$store.dispatch("teams/currentTeam", opening.team);
      this.$router.push({ name: "jobs" });
    },

    searchOpening() {
      this.$store.dispatch("search/currentSearchTerm", this.query);
      this.$router.push({ name: "search", params: { query: this.query } });
    },

    fetchOpenings() {
      this.$store.dispatch("openings/fetchAllOpenings");
    }
  },
  components: { Button, Loader }
};
</script>
